export enum LocalStorageKeys {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  USER_NAME = 'user_name',
  USER_ID = 'user_id',
  USER = 'user',
  ROLES_ENTREPRISE = 'role_entreprise',
  ROLES_ESTABLISHEMENTS = 'role_establishments',
  CANDIDATE_Id = 'candidate_id',
  STORE_ID = 'storeId',
}
